export default __webpack_public_path__ + "static/media/coin1.ea90573f.png";